

































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { goTop } from '@/global/utils';
const Alipay = () => import('@/components/drawcash/alipay.vue');
const Winxin = () => import('@/components/drawcash/weixin.vue');
const Supply = () => import('@/components/drawcash/supply.vue');
const Result = () => import('@/components/drawcash/result.vue');
import {
  getWithdrawals,
  getWithdrawalsCode,
  queryCurrent,
  getVerify,
} from '@/api/user/user';
@Component({
  components: {
    Alipay,
    Winxin,
    Result,
    Supply,
  },
})
export default class Drawcash extends Vue {
  private keyword: string = process.env.VUE_APP_KEYWORD;
  private showStep: boolean = false; // 显示提现表单
  private stepCurrent: number = 0; // 当前进度
  private showZFB: boolean = false; // 提现支付包
  private wxInfo: boolean = false; // 提现微信
  private supplyInfo: boolean = false; // 提现供应商
  private resultInfo: boolean = false; //提现结果
  private resultType: string = 'success'; // 提现结果类型
  private withdrawScope: object[] = []; // 提现金额列表
  private withdrawScopeAli: object[] = []; // 提现金额列表微信
  private withdrawType = 0;
  private withdrawLimit = 0;
  private taxDetail: any = {};
  private amount: any = 100;
  private amounts: object[] = [
    {
      label: '可提现余额',
      desc:
        `该余额可微信、支付宝提现或提供公司增值税专用发票后${this.keyword}进行对公转账付款；如需支付押金，可直接从余额中扣除。`,
      sum: 0,
    },
    {
      label: '待甲方确认额',
      desc:
        `一个任务经过标注、审核、质检、初验后，该任务的金额即进入【待甲方确认额】甲方内部经过确认流程后，该金额变成【可提现余额】用户可进行提现。<a target="_blank" href="https://renwu.longmaosoft.com/docs/showIncome">详情请点击这里查看</a>`,
      sum: 0,
      info:'待甲方确认额调整说明'
    },
    {
      label: '冻结金额',
      desc:
        '该余额包含用户的押金和用户申请对公转账后的暂时冻结金额。押金退还后，将返回到可提现余额中；如扣除押金，直接扣减相应金额；对公转账完成后，同样直接扣减相应金额。',
      sum: 0,
    },
  ];
  private mehods: object[] = [
    {
      label: '支付宝提现',
      button: '提现到支付宝',
      type: 'zfb',
      icon: require('../../assets/imgs/alipayIcon.png'),
      color: 'background: #1890ff',
      border: 'border:1px solid #1890ff',
      font: 'color: #1890ff;border:1px solid #1890ff',
      isShow: true,
    },
    {
      label: '微信提现',
      button: '提现到微信',
      type: 'wx',
      icon: require('../../assets/imgs/weixinLogo.png'),
      color: 'background: #3cb034',
      border: 'border:1px solid #3cb034',
      font: 'color: #3cb034;border:1px solid #3cb034',
      isShow: true,
    },
    {
      label: '供应商专用',
      desc: `1.具有开增值税发票资格的公司可以进行供应商认证
2.认证后的供应商可提供发票使用供应商专用提现通道
3.为了减少提现中问题支付宝与微信通道将会被关闭，只保留供应商专用通道
4.每个公司只可被认证一次，认证信息一旦确认不可修改，成功后不可取消认证
5.单次转账金额最小1000元，每月最多使用供应商专用提现通道一次，按照自然月计算`,
      button: '对公转账',
      icon: require('../../assets/imgs/supplier2x.png'),
      color: 'background: #189ebb',
      border: 'border:1px solid #189ebb',
      font: 'color: #189ebb;border:1px solid #189ebb',
      hot: require('../../assets/imgs/hot.png'),
      type: 'dg',
      isShow: true,
    },
  ];
  private columns: object[] = [
    {
      title: '月收入',
      key: 'income',
    },
    {
      title: `普通用户（使用微信/支付宝通道）
缴纳个人劳务报酬所得税（由${this.keyword}代扣代缴）`,
      key: 'userTax',
    },
    {
      title: `供应商（使用供应商专用通道）
缴纳企业增值税（按照税率3%举例）`,
      key: 'supperTax',
    },
  ];
  private tableData: object[] = [
    {
      income: '800元以内',
      userTax: '0元',
      supperTax: '0元-24元',
    },
    {
      income: '800元-4000元',
      userTax: '0元-640元	',
      supperTax: '24元-120元',
    },
    {
      income: '4000元-25000元',
      userTax: '640元-4000元',
      supperTax: '120元-750元',
    },
    {
      income: '25000元-62500元',
      userTax: '4000元-13000元',
      supperTax: '750元-1875元',
    },
    {
      income: '超过62500元',
      userTax: '13000元以上',
      supperTax: '1875元以上',
    },
  ];

  private created() {
    this.getUserInfo();
    goTop();
  }
  // 获取用户信息
  private async getUserInfo() {
    const userInfo = this.$store.state.userInfo;
    if (userInfo.id) {
      this.useUserInfo(userInfo);
    } else {
      try {
        const res = await queryCurrent('');
        if (typeof res !== 'string') {
          this.$store.commit('setUser', res);
          this.useUserInfo(res);
        } else {
          this.$router.push({ path: 'login' });
        }
      } catch (err) {
        this.$router.push({ path: 'login' });
      }
    }
  }
  private useUserInfo(data) {
    const newarr = this.amounts.slice(0);
    (newarr[0] as any).sum = data.amount / 100;
    (newarr[1] as any).sum = data.uncheck_amount / 100;
    (newarr[2] as any).sum = data.freeze_amount / 100;
    this.amounts = newarr;
    this.withList(data);
    this.mehods.forEach((item: any) => {
      if (item.type == 'dg') {
        item.isShow = data.supplier ? true : false;
      } else {
        item.isShow = data.supplier ? false : true;
      }
    });
  }
  // 获取提取金额列表
  private async withList(userInfo) {
    const res = await getWithdrawals();
    const result = res as any;
    result.amount_list = result.amount_list
      ? result.amount_list
      : ['100', '1000', '2000', '20000', '50000'];
    this.withdrawType = result.type;
    this.withdrawLimit = result.max_withdraw_amount
    if (this.withdrawType == 1) {
      result.amount_list.push('其他金额')
    }

    // 支付宝增加 2000, 去掉 500
    let withdrawScopeAli = result.amount_list.filter(item => item !== 50000)
    if(!withdrawScopeAli.some(item => (item as any) === 200000)) {
      withdrawScopeAli = withdrawScopeAli.concat([200000])
    }

    this.withdrawScopeAli = withdrawScopeAli.map((item, index) => {
      if (item == '其他金额') {
        return {
          label: '其他金额',
          value: -1,
          disable: false,
        };
      } else {
        return {
          label: item / 100 + '元',
          value: item,
          disable: userInfo.amount < item,
        };
      }
    });
    this.withdrawScope = result.amount_list.map((item, index) => {
      if (item == '其他金额') {
        return {
          label: '其他金额',
          value: -1,
          disable: false,
        };
      } else {
        return {
          label: item / 100 + '元',
          value: item,
          disable: userInfo.amount < item,
        };
      }
    });
  }
  get userInfo() {
    return this.$store.state.userInfo;
  }
  @Watch('$route')
  private routechange(to: any, from: any) {
    this.getUserInfo();
  }
  // 切换提现方式
  private handleExtract(type: string) {
    this.showZFB = !1;
    if (type === 'zfb') {
      this.showZFB = true;
      this.showStep = true;
      this.stepCurrent = 1;
    }
    if (type === 'wx') {
      this.showStep = true;
      this.wxInfo = true;
      this.stepCurrent = 1;
    }
    if (type === 'dg') {
      if (this.useUserInfo && this.userInfo.supplier_withdraw_by_month) {
        this.$Modal.info({
          title: '提示',
          content:
            '<div><p>每月最多使用供应商提现通道一次</p><p>请下月再来，按照自然月计算</p></div>',
        });
      } else {
        this.getSupply();
      }
    }
    goTop();
  }
  // 获取供应商信息
  private async getSupply() {
    const resp: any = await getVerify();
    // if (resp.result.verify == 3) {
    //   // 认证中
    //   this.$Modal.info({
    //     title: '认证提示',
    //     content: '<div><p>认证中！预计一周内审核完成</p></div>',
    //   });
    // } else if (resp.result.verify == 2) {
    //   // 认证失败
    //   this.$Modal.error({
    //     title: '认证提示',
    //     content: '<div><p>认证失败</p></div>',
    //   });
    // } else if (resp.result.verify == 4) {
    //   // 未认证
    //   this.$Modal.confirm({
    //     title: '认证提示',
    //     content:
    //       '<p>您还未进行供应商认证，请点击供应商认证或此页面【去认证】，完成认证即可使用对公转账通道</p>',
    //     onOk: () => {
    //       this.$router.push({ path: 'supplier' });
    //     },
    //     onCancel: () => {
    //       console.log('cancel');
    //     },
    //   });
    // } else {
    this.showStep = true;
    this.supplyInfo = true;
    this.stepCurrent = 1;
    // }
  }
  // 提现结果
  private handleResult(type, tex, amount) {
    this.$nextTick(() => {
      this.wxInfo = false;
      this.showZFB = false;
      this.supplyInfo = false;
      this.resultInfo = true;
      this.resultType = type;
      this.taxDetail = tex;
      this.amount = amount;
      this.stepCurrent = 2;
    });
    this.getUserInfo();
  }

  // 返回
  private handleBack() {
    this.showZFB = false;
    this.showStep = false;
    this.wxInfo = false;
    this.supplyInfo = false;
    this.stepCurrent = 0;
    this.goTitleTop();
  }
  // goTop
  private goTitleTop() {
    const top = (document.querySelector('.with-title') as any).offsetTop;
    document.body.scrollTop = document.documentElement.scrollTop = top;
  }
}
